import { useContext } from 'react';

import { LocaleContext } from '@/i18n/LocaleContext';

export function useLocale() {
    return useContext(LocaleContext);
}
